import { h } from "preact";
import { useState, useRef, useLayoutEffect } from "preact/hooks";

import classname from "../../foundation/utils/classname";

import "./style.css";

interface Props {
    /*
        * TODO: src prop should be required but in legacy part of the codebase we're rendering Avatar component without src prop first,
          then updating it to pass the src. We can make this required once we migrate those parts.
    */
    class?: string;
    src?: string;
    srcset?: string;
    type?: "user" | "organization";
    title?: string;
    size?: number;
    bgSize?: number;
}

const DEFAULT_SIZE = 32;

function Avatar({
    class: cssClass,
    src,
    srcset,
    type,
    title,
    size,
    bgSize
}: Props) {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const imageRef = useRef<HTMLImageElement>(null);

    function handleLoad() {
        setLoading(false);
        setError(false);
    }

    function handleError() {
        setError(true);
    }

    useLayoutEffect(() => {
        if (imageRef.current?.src && imageRef.current.complete) {
            handleLoad();
        } else {
            setLoading(true);
            setError(false);
        }
    }, [src, srcset]);

    const classnames = classname("avatarFrame", cssClass, type, { placeholder: loading || error });
    const style = {
        width: size!,
        height: size!,
        backgroundSize: bgSize ?? "contain"
    };

    return (
        <div class={classnames} style={style} title={title}>
            {src && (
                <img
                    ref={imageRef}
                    srcSet={srcset}
                    src={src}
                    width={size}
                    height={size}
                    onLoad={handleLoad}
                    onError={handleError}
                    alt="&#x1f464;"/>
            )}
        </div>
    );
}

Avatar.defaultProps = {
    type: "user",
    size: DEFAULT_SIZE
};

export default Avatar;
